import { useMemo } from "react";

import { useRegionalBackend } from "../context/RegionalBackendContext";

export function useRecordingModeConfig({ uid, mapping }) {
  const regionalBackend = useRegionalBackend();

  return useMemo(() => {
    if (!uid) {
      return {
        loading: false,
        clinicStudyId: null,
        config: null,
        error: null,
        mappingResolved: mapping.resolved,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    if (!mapping.resolved) {
      return {
        loading: true,
        clinicStudyId: null,
        config: null,
        error: null,
        mappingResolved: false,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    const clinicStudyId = mapping.clinicStudyId ?? null;
    const config = regionalBackend.recordingModeConfig ?? null;
    const loadingClinicConfig =
      Boolean(clinicStudyId) &&
      regionalBackend.loading &&
      !config &&
      !regionalBackend.error &&
      !regionalBackend.recordingModeConfigError;

    if (!clinicStudyId) {
      return {
        loading: false,
        clinicStudyId: null,
        config: null,
        error: mapping.error,
        mappingResolved: true,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    if (loadingClinicConfig) {
      return {
        loading: true,
        clinicStudyId,
        config: null,
        error: null,
        mappingResolved: true,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    if (
      regionalBackend.error ||
      regionalBackend.recordingModeConfigError === "unavailable" ||
      mapping.error === "fetch_failed"
    ) {
      return {
        loading: false,
        clinicStudyId,
        config: null,
        error: "fetch_failed",
        mappingResolved: true,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    if (!config) {
      return {
        loading: false,
        clinicStudyId,
        config: null,
        error: "not_found",
        mappingResolved: true,
        mappingLoading: mapping.loading,
        subjectId: mapping.subjectId,
      };
    }

    return {
      loading: false,
      clinicStudyId,
      config,
      error: null,
      mappingResolved: true,
      mappingLoading: mapping.loading,
      subjectId: mapping.subjectId,
    };
  }, [
    mapping.clinicStudyId,
    mapping.error,
    mapping.loading,
    mapping.resolved,
    mapping.subjectId,
    regionalBackend.error,
    regionalBackend.loading,
    regionalBackend.recordingModeConfig,
    regionalBackend.recordingModeConfigError,
    uid,
  ]);
}
